import DOMPurify from "dompurify";

// Sanitize backend/template-rendered HTML (engagement letters, master terms, previews) at the
// render boundary before dangerouslySetInnerHTML. Explicit allowlist: only the formatting markup
// engagement letters/terms actually use. Blocks <script>, <iframe>, <object>/<embed>, <form>/<input>,
// inline event handlers (onclick/onerror/…), and javascript: URLs; DOMPurify also sanitizes style values.
const CONFIG = {
  ALLOWED_TAGS: [
    "b", "strong", "i", "em", "u", "s", "p", "br", "hr", "span", "div",
    "a", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6",
    "table", "thead", "tbody", "tfoot", "tr", "td", "th",
    "blockquote", "mark", "sup", "sub", "small", "pre", "code",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "colspan", "rowspan", "align", "valign", "width", "class", "style"],
  ALLOW_DATA_ATTR: false,
  ALLOWED_URI_REGEXP: /^(?:https?|mailto|tel):/i,
};

export const sanitizeHtml = (html) => DOMPurify.sanitize(html || "", CONFIG);
